import _merge from 'lodash/merge'
import _get from 'lodash/get'
import _set from 'lodash/set'
import { v4 as uuidv4 } from 'uuid'

import { FIELD_TYPE, API_ERROR_SUBTYPES } from '@/constants'

import {
  purgeEmptyFromObject,
  clearHiddenFieldsFromSection,
  clone
} from '@/applicationDefinition/helper'
import applicationSections from '@/applicationDefinition/applicationSections'
import endPoint from './endPoint'
import { ERROR_CODES, DATE_FORMAT, CHOOSE_DATE } from '../constants'
import { addAlert, buildAlerts, buildCounters } from './buildAlerts'
import xhr from './xhr'
import normalise from '@/mock/helper/normalise'
import mockApplication from '@/mock/application'
import moment from 'moment'

const API_BASE = process.env.VUE_APP_API_BASE

function xhrError(dispatch, message) {
  dispatch('hideSpinner')
  alert(message || 'Server did not respond')
}

export default {
  // "set" is a generic action for setting a single
  // state value.
  set({ commit }, keyValueArray) {
    commit('set', keyValueArray)
  },
  // "setError" Matching the content of the error message to the appropriate errorCode
  setError({ commit }, error) {
    commit('set', ['error', error])
  },
  setAPIError({ commit }, { error, fallbackCode }) {
    commit('set', [
      'error',
      {
        errorObject: error,
        response: error.response,
        fallbackCode,
        type: ERROR_CODES.API
      }
    ])
  },
  resetError({ commit }) {
    commit('set', ['error', null])
  },
  showSpinner({ commit }) {
    commit('set', ['showSpinner', true])
  },
  hideSpinner({ commit }) {
    commit('set', ['showSpinner', false])
  },

  openMenu({ commit }) {
    commit('set', ['showOverlay', true])
    commit('set', ['showMenu', true])
  },
  closeMenu({ commit }) {
    commit('set', ['showMenu', false])
    commit('set', ['showOverlay', false])
  },

  setSaveStatus({ commit }, status) {
    commit('set', ['saveStatus', status])
  },

  showMessageBox({ commit }, options) {
    commit('set', ['messageBox', options])
  },
  hideMessageBox({ commit }) {
    commit('set', ['messageBox', {}])
  },

  alertBox(store, options) {
    alert(options.message)
  },

  openModal({ commit }, options) {
    commit('set', ['modal', options])
  },
  closeModal({ commit }) {
    commit('set', ['modal', {}])
  },
  setFocus({ commit }, focusID) {
    commit('set', ['focusID', ''])
    commit('set', ['focusID', focusID])
  },

  setInitialVitalData({ commit }, data) {
    commit('set', [
      'application',
      {
        serviceName: data.serviceName
        
      }
    ])

    commit('set', [
      'currentApplication',
      {
        serviceName: data.serviceName        
      }
    ])    
    
  },

  setUser({ commit }, data) {
    commit('set', ['user', data])
  },
  setWelcome({ commit }) {
    commit('set', [
      'welcomePage',
      {
        test: 'test'
      }
    ]),
      commit('set', ['showSpinner', true])
  },

  getSections({ commit }) {
    commit('set', ['sections', applicationSections])
  },

  getApplication({ commit, state, dispatch }) {
    commit('set', ['application', null])

    const addBlankTemplateRecords = (fields, mock, data) => {
      // Recursively updates our empty application template to ensure each
      // record collection has a blank record for every record in the real data.
      // This allows the real application data to then be merged with our blank
      // template.

      fields.map(field => {
        if (field.type === FIELD_TYPE.COLLECTION) {
          // try to resolve name
          try {
            let fieldMock = _get(mock, field.apiKey)
            const fieldData = _get(data, field.apiKey)

            // only for larger then 1
            if (fieldData && fieldData.length > 1) {
              // make mock same size as data
              for (let i = 0; fieldMock.length < fieldData.length; i++) {
                // dont mutate field
                fieldMock.push(JSON.parse(JSON.stringify(field.newItem)))
              }

              // recursion for complex object
              if (field.fields) {
                fieldData.map((item, index) => {
                  addBlankTemplateRecords(field.fields(data, index), mock, data)
                })
              }
            }
          } catch (ex) {
            // there are some fields empty
          }
        }
      })
    }       

   
      return endPoint
        .getFormData(state.auth.idToken)
        .then(resp => {
          if (
            resp.data.message === 'No pending applications found for this user'
          ) {            
            dispatch('setError', [
              'No pending applications',
              ERROR_CODES.NO_PENDING
            ])

            this.$router.history.push('/error')
          } else if (resp.data.body) {            
            // Merge populated application values into empty template (so we have full
            // json application structure)
            let result = clone(mockApplication)
            state.sections.map(section => {
              addBlankTemplateRecords(
                section.fields,
                result,
                resp.data.body.application
              )
            })
            result = _merge(result, resp.data.body.application)           
            
            commit('set', ['application', result])
          }
        })
        .catch(error => {
          dispatch('hideSpinner')
          dispatch('setAPIError', {
            error,
            fallbackCode: API_ERROR_SUBTYPES.getApplication
          })
          this.$router.history.push('/error')
        })
   // }
  }, 

  initiateAuth({ commit }, { email, recaptchaVerifyToken }) {
    return endPoint
      .getAuthCognitoSession(email, recaptchaVerifyToken)
      .then(resp => {
        // Save userID and cognitoSession to store
        commit('set', ['auth.userId', email])
        commit('set', ['auth.cognitoSession', resp.data.body.cognitoSession])
      })
  },

  getReferenceData({ commit }) {
    return endPoint
      .getReferenceData()
      .then(res => commit('set', ['refData', normalise.refData(res.data)]))
  },

  getCounties({ commit }) {
    return endPoint
      .getCounties()
      .then(res => commit('set', ['counties', res.data]))
  },

  getOESProperties({ commit }) {
    return endPoint
      .getOESProperties()
      .then(res => commit('set', ['oesProperties', res.data]))
  },
 
  
  
  cancelApplication({ state }) {
    return endPoint.cancelApplication(state.auth.idToken)
  },

  buildAlerts(store) {
    buildAlerts(store)
  },
  addAlert(store, data) {
    let { commit, state } = store
    addAlert(commit, state, data.section, data.field, store)
  },

  buildCounters(store) {
    buildCounters(store)
  },

  toggleSection({ commit, state }, section) {
    commit('set', [
      'application.meta.sectionExpandedId',
      section.id !== state.application.meta.sectionExpandedId
        ? section.id
        : null
    ])

    commit('set', ['auth.isUserActive', true])
    commit('set', ['auth.isUserActiveTime', new Date().getTime()])
  },

  createApplication({ dispatch, state }) {
    // Package data for sending
    let putData = clone(state.application)

    // Purge empty as ERM require
    const putDataPurge = purgeEmptyFromObject(putData)

    dispatch('showSpinner')

    return endPoint
      .createApplication(state.auth.idToken, putDataPurge)
      .then(() => {
        // Clear counters on successful section save
        dispatch('set', ['counters', []])
        dispatch('hideSpinner')
      })
  },

  saveFullFormInOTP({ dispatch, state }) {
    if (state.showSpinner) return

    // Package data for sending
    let putData = clone(state.application)

    // Purge empty as ERM require
    const putDataPurge = purgeEmptyFromObject(putData)

    dispatch('showSpinner')

    return xhr
      .put(
        `${API_BASE}/applications/self`,
        {
          application: putDataPurge
        },
        {
          headers: {
            Pragma: 'no-cache',
            Authorization: `Bearer ${state.auth.idToken}`
          }
        }
      )
      .then(() => {
        // Clear counters on successful section save
        dispatch('set', ['counters', []])
        dispatch('hideSpinner')
      })
  },

  saveApplicationSection({ dispatch, state }, data) {
    const saveSectionId = data.section.id

    // TODO(PK): Don't rely on text strings
    if (state.saveStatus === 'Saving...') return

    // eslint-disable-next-line
    const processMerge = (field, oData, nData) => {
      // Special case: GROUPs
      if (field.type === FIELD_TYPE.GROUP) {
        field.fields().forEach(field => processMerge(field, oData, nData))
        return
      }

      // Ignore heading field
      if (field.type !== FIELD_TYPE.HEADING) {
        _set(oData, field.apiKey, _get(nData, field.apiKey))
      }
    }

    // Package data for send
    let putData = clone(state.application)

    data.section.fields.map(field => {
      processMerge(field, putData, state.application)
    })

    // Only override section if next section is specified
    putData.meta.sectionExpandedId = state.application.meta.sectionExpandedId

    if (data.type === 'next') {
      const SectionIndex = applicationSections.findIndex(
        item => item.id === saveSectionId
      )
      putData.meta.sectionExpandedId = applicationSections[SectionIndex + 1].id
    }

    // Purge empty fields (ERN requirement)
    const putDataPurge = purgeEmptyFromObject(putData)

    dispatch('set', ['saveStatus', 'saving'])

    // Endpoint refactor
    return endPoint
      .saveApplication(state.auth.idToken, putDataPurge)
      .then(() => {
        dispatch('set', ['saveStatus', 'saved'])

        // Navigate to next section
        if (data.type === 'next') {
          //clear the hidden fields
          let clearedApplication = clearHiddenFieldsFromSection(
            data.section.fields,
            state.application
          )
          dispatch('set', ['application', clearedApplication])

          dispatch('set', [
            'application.meta.sectionExpandedId',
            putData.meta.sectionExpandedId
          ])
        } else if (data.type === 'close') {
          window.close()
        }
      })
  },

  gotoApplicationSection({ dispatch, state }, data) {
    if (state.showSpinner) {
      return
    }

    // package data for send
    let putData = clone(state.application)

    // only override section if next section is specified
    if (data.type === 'next') {
      const SectionIndex = applicationSections.findIndex(
        item => item.id === data.section.id
      )
      putData.meta.sectionExpandedId = applicationSections[SectionIndex + 1].id
    }

    // purge empty as ERM require
    const putDataPurge = purgeEmptyFromObject(putData)

    dispatch('showSpinner')
    xhr
      .put(
        `${API_BASE}/applications/self`,
        {
          application: putDataPurge
        },
        {
          headers: {
            Pragma: 'no-cache',
            Authorization: `Bearer ${state.auth.idToken}`
          }
        }
      )
      .then(() => {
        dispatch('hideSpinner')

        // merge back into application once successful
        dispatch('set', ['application', putData])

        // navigate to next section
        if (data.type === 'next') {
          dispatch('set', [
            'application.meta.sectionExpandedId',
            putData.meta.sectionExpandedId
          ])
        } else if (data.type === 'close') {
          window.close()
        }
      })
      .catch(function(error) {
        xhrError(dispatch, error)
      })
  },

  pushNotification({ commit, state }, notification) {
    const id = uuidv4()
    const newNotification = { ...notification, id }
    const notifications = state.notificationQueue || []
    commit('set', ['notificationQueue', [...notifications, newNotification]])
    return id
  },

  popNotification({ commit, state }) {
    const notifications = [...state.notificationQueue] || []
    notifications.shift()
    commit('set', ['notificationQueue', notifications])
  },

  dismissNotification({ commit, state }, idOrIndex) {
    const notifications = [...state.notificationQueue] || []
    let index
    if (typeof idOrIndex === 'number') {
      //idOrIndex is ths index
      index = idOrIndex
    } else {
      //idOrIndex is ths id
      index = notifications.findIndex(
        notification => notification.id === idOrIndex
      )
    }
    if (index !== -1) {
      notifications.splice(index, 1)
      commit('set', ['notificationQueue', notifications])
    }
  },

  logout({ commit, state }) {
    commit('set', ['auth.idToken', null])
    commit('set', ['auth.refreshToken', null])
    commit('set', ['alerts', []])   
  },

  setUploadingStatus({ commit, state }, uploadObject) {
    commit('set', [
      'uploadStatuses',
      { ...state.uploadStatuses, ...uploadObject }
    ])
  }
}
